// FILTER MASK FOR NUMBER AND DOT
export function filterMask (field, value, state, setter) {
  if (value && value !== undefined) value = `${value.replace(/[^.0-9]*/g, '')}`;
  setter({...state, [field]: value});
}